import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { clearCache } from "@/lib/offline";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        const r = await api.post("/auth/refresh");
        setUser(r.data);
      } catch (e) {
        setUser(false);
      }
    });
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    clearCache();
    setUser(false);
  }, []);

  const can = useCallback((perm) => !!user && (user.permissions || []).includes(perm), [user]);

  return <AuthContext.Provider value={{ user, setUser, login, logout, can }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
